import type { TFunction } from "i18next";

import { ROUTINE_SLOTS, type RoutineDay } from "~/lib/routine";

/**
 * "Tuesday 22 September – morning taken, evening not taken": what the dose dots say,
 * for assistive technology. Shared by the week strip and the month grid, which draw
 * the same dots.
 */
export function dayStatusLabel(
  t: TFunction,
  date: string,
  doses: RoutineDay | undefined,
): string {
  const [morning, evening] = ROUTINE_SLOTS.map((slot) =>
    t(
      doses?.[slot] !== undefined
        ? "routine.statusTaken"
        : "routine.statusMissing",
    ),
  );
  return t("routine.dayStatus", { date, morning, evening });
}
